export type AddRemoveDisabledReason = 'viewerSelf' | 'companyGroupAdmin'

const ADD_REMOVE_DISABLED_TOOLTIP: Record<AddRemoveDisabledReason, string> = {
  viewerSelf: 'You cannot change your own access.',
  companyGroupAdmin:
    'Company group administrators by default have access to all companies in the group.',
}

export function getAddRemoveDisabledTooltip(
  reason: AddRemoveDisabledReason
): string {
  return ADD_REMOVE_DISABLED_TOOLTIP[reason]
}
